import React, { useState, useEffect } from "react";
import { Card, Nav, Tab } from "react-bootstrap";
import { TableItemSumberDayaSection } from "../Section/TableItemSumberDayaSection";
import { SubKegiatanApi } from "api";
import Axios from "axios";
import { TableAsetSection, TableItemMaterialManusiaSection } from "../Section";

export const TabItemSumberDaya = ({ type }) => {
  const [dropdown, setDropdown] = useState({
    kategoriLainnya: [],
    kategoriOverhead: [],
    itemSumberDayaMaterial: [],
    itemSumberDayaManusia: [],
    itemSumberDayaPeralatan: [],
    itemSumberDayaOverhead: [],
    itemSumberDayaLainnya: [],
    sumberPengadaan: [],
    grupAset: [],
  });

  const getDropdown = () => {
    Axios.all([
      SubKegiatanApi.dropdownKategoriAnggaran({ is_lainnya: "1" }),
      SubKegiatanApi.dropdownKategoriAnggaran({ is_lainnya: "0" }),
      SubKegiatanApi.dropdownItemSumberDayaBuaso({ nama_bahan: "1" }),
      SubKegiatanApi.dropdownItemSumberDayaBuaso({ id_buaso: "2" }),
      SubKegiatanApi.dropdownItemSumberDayaBuaso({ id_buaso: "4" }),
      SubKegiatanApi.dropdownItemAset({
        nama_grup_aset: "Alat Dan Mesin",
      }),

      SubKegiatanApi.dropdownSumberPengadaan(),
      SubKegiatanApi.dropdownGrupAset(),
    ]).then(
      Axios.spread(
        (
          kategoriLainnya,
          kategoriOverhead,
          sumberDayaBahan,
          sumberDayaUpah,
          sumberDayaSubkon,
          sumberDayaAlatMesin,
          sumberPengadaan,
          grupaset
        ) => {
          const mappingKategori = (data) =>
            data.map((val) => ({
              label: val.nama_kategori_anggaran,
              value: val.id_kategori_anggaran,
            }));

          const mappingItemSumberDayaBuaso = (data) =>
            data.map((val) => ({
              label: val.nama_item,
              value: val.id_item_buaso,
              namaSatuan: val.nama_satuan,
            }));

          const mappingItemAlatMesin = (data) =>
            data.map((val) => ({
              label: val.nama_item_aset,
              value: val.id_item_aset,
            }));

          const mappingSumberPengadaan = (data) =>
            data.map((val) => ({
              label: val.nama_sumber_pengadaan,
              value: val.id_sumber_pengadaan,
            }));
          const mappingGrupAset = (data) =>
            data.map((val) => ({
              label: val.nama_grup_aset,
              value: val.id_grup_aset,
            }));

          setDropdown({
            ...dropdown,
            kategoriLainnya: mappingKategori(kategoriLainnya?.data?.data ?? []),
            kategoriOverhead: mappingKategori(
              kategoriOverhead?.data?.data ?? []
            ),
            itemSumberDayaMaterial: mappingItemSumberDayaBuaso(
              sumberDayaBahan?.data?.data ?? []
            ),
            itemSumberDayaManusia: mappingItemSumberDayaBuaso([
              ...sumberDayaUpah?.data?.data,
              ...sumberDayaSubkon?.data?.data,
            ]),

            itemSumberDayaPeralatan: mappingItemAlatMesin(
              sumberDayaAlatMesin?.data?.data ?? []
            ),
            sumberPengadaan: mappingSumberPengadaan(
              sumberPengadaan?.data?.data ?? []
            ),
            grupAset: mappingGrupAset(grupaset?.data?.data ?? []),
          });
        }
      )
    );
  };

  useEffect(() => {
    getDropdown();

    return () => {};
  }, []);

  return (
    <Card className="p-0 m-0">
      <Tab.Container defaultActiveKey="material">
        <Card.Header className="d-flex justify-content-between align-items-center">
          <Nav variant="tabs">
            <Nav.Item>
              <Nav.Link eventKey="material">Sumber Daya Material</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="manusia">Sumber Daya Manusia</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="peralatan">Sumber Daya Peralatan</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="overhead">
                Sumber Daya Biaya Overhead
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="lainnya">Sumber Daya Lainnya</Nav.Link>
            </Nav.Item>
          </Nav>
        </Card.Header>
        <Tab.Content>
          <Tab.Pane eventKey="material">
            <div className="py-3 px-2">
              <span style={{ fontSize: "14px" }}>
                <b>List Data Item Sumber Daya Material</b>
              </span>
              <TableItemMaterialManusiaSection
                dropdownItem={dropdown?.itemSumberDayaMaterial}
                dropdownPengadaan={dropdown?.sumberPengadaan}
                tabType="material"
                type={type}
              />
            </div>
          </Tab.Pane>
          <Tab.Pane eventKey="manusia">
            <div className="py-3 px-2">
              <span style={{ fontSize: "14px" }}>
                <b>List Data Item Sumber Daya Manusia</b>
              </span>
              <TableItemMaterialManusiaSection
                dropdownItem={dropdown?.itemSumberDayaManusia}
                dropdownPengadaan={dropdown?.sumberPengadaan}
                tabType="manusia"
                type={type}
              />
            </div>
          </Tab.Pane>
          <Tab.Pane eventKey="peralatan">
            <div className="py-3 px-2">
              <span style={{ fontSize: "14px" }}>
                <b>List Data Item Sumber Daya Peralatan</b>
              </span>
              <TableAsetSection
                dropdown={dropdown}
                tabType="peralatan"
                type={type}
              />
            </div>
          </Tab.Pane>
          <Tab.Pane eventKey="overhead">
            <div className="py-3 px-2">
              <span style={{ fontSize: "14px" }}>
                <b>List Data Item Sumber Daya Biaya Overhead</b>
              </span>
              <TableItemSumberDayaSection
                dropdown={dropdown}
                tabType="overhead"
                type={type}
              />
            </div>
          </Tab.Pane>
          <Tab.Pane eventKey="lainnya">
            <div className="py-3 px-2">
              <span style={{ fontSize: "14px" }}>
                <b>List Data Item Sumber Daya Lainnya</b>
              </span>
              <TableItemSumberDayaSection
                dropdown={dropdown}
                tabType="lainnya"
                type={type}
              />
            </div>
          </Tab.Pane>
        </Tab.Content>
      </Tab.Container>
    </Card>
  );
};
